import React, { useContext, useEffect, useMemo } from "react";
import { isEmpty } from "@swiggy-private/js-utils";
import { SwiggyHeadersContext } from "@swiggy-private/swiggy-money-context/src";
import { getBridgeSdk, initBridgeSdk } from "utils/bridgeSdk";
import { getDynamicFlags, getSwiggyHeadersFromNB } from "utils/NativeBridge";

export function useLogin(setPlayLottie?: React.Dispatch<React.SetStateAction<boolean>>): void {
    const sdk = useMemo(() => initBridgeSdk(), []);
    const { swiggyHeaders, setSwiggyHeaders, setDynamicFlags } = useContext(SwiggyHeadersContext);

    useEffect(() => {
        if (!isEmpty(swiggyHeaders)) {
            if (isEmpty(swiggyHeaders.userid) || isEmpty(swiggyHeaders.tid)) {
                getBridgeSdk()
                    .login()
                    .then(async (response) => {
                        try {
                            if (!response || !response.hasLoggedIn) {
                                return false;
                            }

                            const headers = await getSwiggyHeadersFromNB(sdk);
                            const dynamicFlags = await getDynamicFlags(sdk);

                            if (dynamicFlags) {
                                setDynamicFlags(dynamicFlags);
                            }
                            if (headers) {
                                setSwiggyHeaders(headers);
                                setPlayLottie?.(true);
                            }
                        } catch (_error) {
                            getBridgeSdk()
                                .close()
                                .catch(() => void 0);
                        }
                    })
                    .catch(() => void 0);
            } else {
                setPlayLottie?.(true);
            }
        }
    }, [sdk, setDynamicFlags, setPlayLottie, setSwiggyHeaders, swiggyHeaders]);
}
